import { useContext } from "react"
import { ServiceStatusContext } from "../providers/ServiceStatusProvider"
import { ServiceStatus } from "@ap-frontend/types"

const useServiceStatus = (): ServiceStatus | undefined => {
  return useContext(ServiceStatusContext)
}

export default useServiceStatus
